"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Wheat, Droplet, Flame, Leaf, Package, Boxes, Beaker, Gem } from "lucide-react";
export default function ProductsCommodities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const commodities = [{
    id: 1,
    name: "Coffee & Cacao",
    icon: Leaf,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/coffee_beans_macro.png"
  }, {
    id: 2,
    name: "Grains & Cereals",
    icon: Wheat,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/wheat_grains_texture.png"
  }, {
    id: 3,
    name: "Spices & Herbs",
    icon: Flame,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/spices_macro_texture.png"
  }, {
    id: 4,
    name: "Oils & Fats",
    icon: Droplet,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/oil_droplets_macro.png"
  }, {
    id: 5,
    name: "Pulses & Seeds",
    icon: Package,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/pulses_seeds_texture.png"
  }, {
    id: 6,
    name: "Sugar & Sweeteners",
    icon: Boxes,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/sugar_crystals_macro.png"
  }, {
    id: 7,
    name: "Industrial Chemicals",
    icon: Beaker,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/chemical_crystals_texture.png"
  }, {
    id: 8,
    name: "Raw Minerals",
    icon: Gem,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/mineral_texture_macro.png"
  }];
  return <section id="products-commodities" className="dark bg-background text-foreground py-24 px-4 overflow-hidden" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-4 text-white">
            Products & Commodities
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Premium global commodities sourced with precision, quality-assured, and delivered on time.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {commodities.map((commodity, i) => {
          const Icon = commodity.icon;
          return <Card key={commodity.id} data-index={i} className={`group relative overflow-hidden cursor-pointer border-0 bg-transparent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: isVisible ? `${i * 80}ms` : "0ms"
          }}>
                <div className="relative h-72 overflow-hidden rounded-sm">
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[600ms] ease-out group-hover:scale-[1.02]" style={{
                backgroundImage: `url(${commodity.image})`
              }} />
                  <div className="absolute inset-0 bg-gradient-to-b from-primary/60 via-primary/70 to-primary/90" />
                  
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent origin-left scale-x-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-x-100" />

                  <CardContent className="relative h-full flex flex-col justify-end p-6 text-white">
                    <div className="mb-4">
                      <Icon className="w-10 h-10 text-accent stroke-[1.5]" />
                    </div>
                    <h3 className="font-display text-xl font-semibold">
                      {commodity.name}
                    </h3>
                  </CardContent>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}